export default "__VITE_ASSET__584677eb__"